import axios from "axios";
import { TOKEN_STORAGE_KEY } from "contexts/sessionContext";

axios.defaults.baseURL = process.env.REACT_APP_API_URL + "/v2";

axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    config.headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axios;
